import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash-es';

import { SimpleDropDown } from 'components/simple-dropdown';
import {
  getShareViaEmailSelector,
  getShareViaYammerSelector,
  getShareViaMicrosoftTeamsSelector,
  getShareViaFacebookSelector,
  getShareViaTwitterSelector,
  getShareDirectLinkSelector,
} from 'common/selectors/index';
import { MsTeamsButtonDecorated } from './ms-teams-button';
import { YammerButtonDecorated } from './yammer-button';
import { EmailButtonDecorated } from './email-button';
import { FacebookButton } from './facebook-button';
import { TwitterButton } from './twitter-button';
import { DirectLinkButton } from './direct-link-button';
import { faShareAlt } from '@fortawesome/pro-regular-svg-icons';

export const VideoShareDropdownDecorated = () => {
  const { t } = useTranslation();

  const facebookFeature = useSelector(getShareViaFacebookSelector);
  const yammerFeature = useSelector(getShareViaYammerSelector);
  const microsoftTeamsFeature = useSelector(getShareViaMicrosoftTeamsSelector);

  const isShareViaTwitterEnabled = useSelector(getShareViaTwitterSelector);
  const isShareViaEmailEnabled = useSelector(getShareViaEmailSelector);
  const isShareViaMicrosoftTeamsEnabled = get(microsoftTeamsFeature, 'enabled');
  const isShareViaYammerEnabled = get(yammerFeature, 'enabled') && get(yammerFeature, 'loaded');
  const isShareViaFacebookEnabled = get(facebookFeature, 'enabled') && get(facebookFeature, 'loaded');
  const isShareDirectLinkEnabled = useSelector(getShareDirectLinkSelector);

  const isVisible =
    isShareViaEmailEnabled ||
    isShareViaMicrosoftTeamsEnabled ||
    isShareViaYammerEnabled ||
    isShareViaFacebookEnabled ||
    isShareViaTwitterEnabled ||
    isShareDirectLinkEnabled;

  if (!isVisible) {
    return null;
  }

  return (
    <div className="ct-video-share-options ct-video-share-options--share" data-e2e="video-share">
      <SimpleDropDown title={t('share')} icon={faShareAlt} flexGrow aria-label={t('video-share-menu')}>
        <EmailButtonDecorated />
        <MsTeamsButtonDecorated />
        <YammerButtonDecorated />
        <FacebookButton />
        <TwitterButton />
        <DirectLinkButton />
      </SimpleDropDown>
    </div>
  );
};
